<template>
  <div id="videoplay">

    <div class="player" v-show="ready">
      <video-player
        class="vjs-custom-skin"
        ref="videoPlayer"
        :options="playerOptions"
        webkit-playsinline
        x5-video-player-type="h5"
        playsinline
        controls="false"
        v-if="ready"
      ></video-player>

      <!--组件遮罩层-->
    </div>

  </div>
</template>








<script>
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

// videojs
import videojs from "video.js";
window.videojs = videojs;

// hls plugin for videojs6
require("videojs-contrib-hls/dist/videojs-contrib-hls.js");



export default {
  name: "videoplay",
  components: {},
  data() {
    return {
      ready: false,
      info: [],
      liveUrl: "",
      playerOptions: {
        // videojs and plugin options
        autoplay: false, //如果true,浏览器准备好时开始回放。
        sources: [
          {
            withCredentials: false,
            type: "application/x-mpegURL"
          }
        ],
        controlBar: false,
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } }
      }
    };
  },
  methods: {
    /**处理播放数据 */
    videoSource() {
      let _this = this;
      let data = {};
      if (this.$route.query.roomnumber != undefined) {
        data.roomnumber = this.$route.query.roomnumber;
      }
      this.$jsonp(this.$apis("liveUrl"), data, res => {
        if (res.data.data.result.length == 0) {
          //未直播状态，转至个人主页
          _this.$router.push({path:"/person?userid=" + data.roomnumber,replace:true})
        }else{
          //正在直播
          _this.info = res.data.data.result;
          _this.liveUrl = res.data.data.result.url;
          _this.aliPlayer();
        }
      });
    },
    deBk() {
      //取消video插件的背景
      let v = this.$tool.getByC("video-js")[0];
      v.style.background = "none";
      v.style.height = "100vh";
      //让video内容充满整个屏幕
      let video = this.$tool.getByItem("video")[0];
      video.style.objectFit = "fill";
      //将播放按钮的层级提升到最高
      let pB = this.$tool.getByC("vjs-big-play-button")[0];
      pB.style.zIndex = "20";
    },
    /**初始化阿里云播放器 */
    aliPlayer() {
      let _this = this;
      let myPlayer = _this.$refs.videoPlayer.player;
      myPlayer.src(_this.liveUrl);
      this.ready = true;
      this.deBk();
    }
  },
  mounted: function() {
    this.$emit("showOhidden", false, 3);
    this.$tool.setTitle("视频播放");
    console.log("视频播放页面");
    // this.videoSource();
    //这个页面废弃了
  }

};
</script>













<style scoped>
body {
  height: 100%;
}
#videoPlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/zhibobk.jpg") no-repeat left top;
  background-size: 100% 100%;
  z-index: 20;
}
.player {
  height: 100%;
}
.video-js {
  height: 100%;
  background: none;
}

.vjs-big-play-button {
  z-index: 90;
}

.shell {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  padding: 0.5rem;
}

.chat {
  left: 0.5rem;
  width: 70%;
  max-height: 30%;
  bottom: 3.5rem;
}
</style>
